export interface Question {
  id?: string;  // Make optional since creation doesn't include it
  questionId?: string;  // Add this to match backend response
  category: string;
  question: string;
  answer: string;
  difficulty: 'EASY' | 'MEDIUM' | 'HARD';
  questionType: 'FREE' | 'PAYED';  // Add question type field
  questionThumbnailUrl?: string;
  answerThumbnailUrl?: string;
  answerRange?: number;  // Add answer range field
  verified?: boolean;  // Changed from isVerified to verified
}
export interface QuestionResponse {
  data: Question[];
  status: number;
  message?: string;
}

export interface SingleQuestionResponse {
  data: Question;
  status: number;
  message?: string;
}

export interface PaginatedQuestionResponse {
  data: Question[];
  totalElements: number;
  totalPages: number;
  currentPage: number;
  size: number;
  status: number;
  message?: string;
}

export interface PaginatedQuestionResponse {
  content: Question[];
  // Add other pagination properties as needed
}

export interface UnansweredQuestionsParams {
  userId: string;
  category: string;
  limit?: number;
  difficulty?: string;
}

export enum QuestionType {
  FREE = 'FREE',
  PAYED = 'PAYED',
}